'use strict';

/* eslint no-undef: "off" */
/**
 * XPark trending now
 */
define('xparkTrendingNow',['xparkHomepageApi'], function (xparkHomepageApi) {
  return {
    template: '\n      <section class="xp-trending-now" v-if="tabs.length || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="tabs.length">\n          <h2>Trending Now</h2>\n\n          <nav class="xp-trending-tabs" aria-label="Trending categories">\n            <button\n              v-for="tab in tabs"\n              :key="tab.key"\n              type="button"\n              :class="{\'is-active\': activeTab === tab.key}"\n              @click="selectTab(tab.key)"\n              v-text="tab.label"\n            ></button>\n          </nav>\n\n          <a class="xp-trending-hero" :href="hero.url" :aria-label="hero.title">\n            <img :src="hero.image" :alt="hero.title" />\n          </a>\n\n          <div class="xp-trending-products">\n            <a\n              v-for="item in currentProducts"\n              :key="item.product_id || item.id || item.item_id || item.sku || item.name || item.product_name"\n              class="xp-trending-product"\n              :href="getProductUrl(item)"\n              :aria-label="getProductTitle(item)"\n            >\n              <img :src="getProductImage(item)" :alt="getProductTitle(item)" />\n              <strong v-text="getProductTitle(item)"></strong>\n              <span v-text="item.slogan || \'\'"></span>\n            </a>\n          </div>\n\n          <a class="xp-trending-view-all" :href="viewAllUrl">View All</a>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        activeTab: '',
        viewAllUrl: 'javascript:void(0);',
        tabs: [],
        hero: {
          image: '',
          title: '',
          url: 'javascript:void(0);'
        },
        productsMap: {},
        categoriesMap: {},
        loading: true
      };
    },

    computed: {
      currentProducts: function currentProducts() {
        return this.productsMap[this.activeTab] || [];
      }
    },
    mounted: function mounted() {
      this.fetchTrendingNow();
    },

    methods: {
      fetchTrendingNow: function fetchTrendingNow() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getTrendingNow().then(function (data) {
          var list = data && data.trending_now_list;

          if (!Array.isArray(list) || !list.length) {
            return;
          }

          var productsMap = {};
          var categoriesMap = {};
          _this.tabs = list.map(function (item, index) {
            var key = item.category_name || 'tab_' + index;
            productsMap[key] = _this.normalizeProducts(item.products || []);
            categoriesMap[key] = item;

            return {
              key: key,
              label: item.category_name || ''
            };
          }).filter(function (item) {
            return item.label;
          });

          _this.productsMap = productsMap;
          _this.categoriesMap = categoriesMap;
          _this.activeTab = _this.tabs[0] ? _this.tabs[0].key : '';
          _this.setHeroFromCategory(_this.categoriesMap[_this.activeTab]);
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      selectTab: function selectTab(key) {
        this.activeTab = key;
        this.setHeroFromCategory(this.categoriesMap[key]);
      },
      normalizeProducts: function normalizeProducts(products) {
        var _this2 = this;

        return (products || []).filter(function (item) {
          return Boolean(_this2.getProductImage(item) && _this2.getProductTitle(item));
        });
      },
      getProductImage: function getProductImage(item) {
        return item.product_image || item.image || '';
      },
      getProductTitle: function getProductTitle(item) {
        return item.product_name || item.name || item.title || '';
      },
      getProductUrl: function getProductUrl(item) {
        return item.product_link || item.url_link || item.product_url || item.url || 'javascript:void(0);';
      },
      setHeroFromCategory: function setHeroFromCategory(item) {
        if (!item) {
          return;
        }

        this.hero = {
          image: item.category_image || '',
          title: item.category_name || '',
          url: item.redirect_url || 'javascript:void(0);'
        };
        this.viewAllUrl = item.redirect_url || 'javascript:void(0);';
      }
    }
  };
});
